import './PagePlaceholder.css';

interface Props {
  title: string;
  subtitle?: string;
}

export function PagePlaceholder({ title, subtitle = 'Page under construction' }: Props) {
  return (
    <div className="page-placeholder">
      <div className="page-placeholder__title">{title}</div>
      <div className="page-placeholder__subtitle">{subtitle}</div>
    </div>
  );
}
